var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageLayout',[_c('PageHeader',{attrs:{"title":_vm.$t(`Common.title.homeTitle`)}}),_c('div',{staticClass:"px-4"},_vm._l((_vm.entries),function(entry,index){return _c('EntryButton',{key:index,attrs:{"hasIcon":false,"label":entry.name},on:{"click":function($event){return _vm.onClick(entry)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }